<template>
    <div>
        <app-gridviewmaintenance
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItemHandler="deleteItemHandler($event)"
            v-on:NewPressedHandler="newRecordHandler"
        ></app-gridviewmaintenance>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
import moment from 'moment';
import GridViewMaintenance from "../../../components/settings/workflowmaintenance/NewGrid";
import ErrorDialog from "../../../components/common/ErrorDialog";
//import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridviewmaintenance': GridViewMaintenance,
        'app-error': ErrorDialog,
    },  
    
    data() {
        return {
            pageTitle: this.$t('recworkflowmaintenance.workflowmaintenancelist'),
            dataHeader: [
                {text: this.$t('columns.actions'), value: 'action', sortable: false, width:'80px'},
                {text: this.$t('columns.workflowtype'), value: 'wftypedesc', width: '200px'},
                {text: this.$t('recworkflowmaintenance.recid'), value: 'recordid', width: '150px'},
                {text: this.$t('columns.staffcode'), value: 'staffcode', width: '150px'},
                {text: this.$t('columns.staffname'), value: 'psnname', width: '250px'},
                {text: this.$t('columns.company'), value: 'compnyname', width: '200px'},
                {text: this.$t('columns.recorddate'), value: 'recdate', width: '200px'},
            ],
            dataItems: [],
            leaveTypeHolder: [],
            isErr: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        // ⚠️ CHANGED: converted from .then().catch() to async/await
        async loadWorkflows() {
            try {
                // All user types (including HR Admin) see every pending workflow.
                // Previously HR Admin was routed to a filtered endpoint that only
                // returned workflows they were personally the approver of, which hid
                // records (e.g. HR Admins with nothing assigned saw an empty list).
                const url = `/workflowmaintenancenew/all`;

                const res = await this.$store.dispatch('get', {url});

                if (res.data.error) {
                    this.isErr = true;
                    this.errMsg = res.data.error;
                    return;
                }

                this.dataItems = res.data.rec;

                for (let i = 0; i < this.dataItems.length; i++) {
                    if (this.dataItems[i].recdate) {
                        this.dataItems[i].recdate = moment(this.dataItems[i].recdate).format('YYYY-MM-DD');
                    }
                }

                // console.log('dataitems', this.dataItems);

            } catch (err) {
                this.isErr = true;
                this.errMsg = err.message || err;
            }
        },

        loadLeaveType() {
            const vm = this;
            
            this.$store.dispatch('get', {
                url: `/leavetype/all`
            })
            .then (function (res) {
                this.leaveTypeHolder = res.data.rec;
            })
            .catch (err => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
            
        },

        detailHandler() {
            const vm = this;
            for (let i = 0; i < vm.dataItems.length; i++) {
                if (vm.dataItems[i].wftypeid == 3) {
                    let item = this.leaveTypeHolder.filter(val => val.id == vm.dataItems[i].detailid)[0]
                    vm.dataItems[i].detaildesc = item.leavedesc
                }
            }
        },

        editItemHandler(item) {
            const isTran = item.wftypecode === 'REVIEW' || item.wftypecode === 'KPISETTING';
            this.$router.push({name: 'workflowmaintenanceedit', params: { id: item.id, search: item.search, isTran }});
        },

        newRecordHandler() {

          //  this.$router.push({name: 'workflowmaintenancenew'});
        }
    },

    async mounted() {
        await this.loadWorkflows();
    }
}
</script>